import React from 'react';
import * as rdd from 'react-device-detect';
import PaoTung from 'assets/paotung.png';
import { POST } from 'api/api';
import DrawCountdown from './DrawCountdown';
import PlaceholderImage from 'assets/logo_full.png';
import { LazyLoadImage } from "react-lazy-load-image-component";
import SectionHeader from 'components/common/SectionHeader';

const OtherApps = ({ nextLottoTimestamp }) => {
  const handleAnchorClick = async (event) => {
    try {
      await POST('/lotto/action', { ctaType: event.target.id, ctaDetail: 'lead to ' + event.target.id });
    } catch (error) {
      console.error('/lotto/action --> error: ', error);
    }
  };

  return (
    <section className="partner-card" aria-label="ซื้อสลาก">
      <SectionHeader
        icon="🎫"
        title="ซื้อสลากออนไลน์"
        subtitle="ซื้อเลขเด็ดของคุณได้ที่ เป๋าตัง"
      />
      <DrawCountdown nextLottoTimestamp={nextLottoTimestamp} />
      <a
        href={
          rdd.isIOS
            ? "https://apps.apple.com/th/app/%E0%B9%80%E0%B8%9B-%E0%B8%B2%E0%B8%95-%E0%B8%87/id1324902182?l=th"
            : "https://play.google.com/store/apps/details?id=com.ktb.customer.qr&hl=th&gl=US"
        }
        rel="noreferrer"
        onClick={handleAnchorClick}
        className="partner-card__link"
      >
        <LazyLoadImage
          id="paotung"
          title="Hotto x Paotung"
          alt="เป๋าตัง App"
          src={PaoTung}
          loading="lazy"
          className="paotung"
          placeholdersrc={PlaceholderImage}
          effect="blur"
        />
      </a>
    </section>
  );
};

export default OtherApps;
